<template>
    
    
    <footer class="tbg_footer clearfix">
        <div class="container">
            <div class="row">
                <div class="col-md-3">
                    <h2>Tree Builders Group, Inc.</h2>
                    <p>Building beautiful homes with strong construction. </p>
                </div>
                <div class="col-md-3">
                    <h4>Quick Links</h4>
                    <ul class="footerLinks">
                        <li><a href="#">Free Estimate</a></li>
                        <li><a href="#">Services</a></li>
                        <li><a href="#">Project Gallery</a></li>
                        <li><a href="#">About</a></li>
                        <li><a href="#">Blog</a></li>
                        <li><a href="#">Career</a></li>
                        <li><a href="#">Privacy Policy</a></li>
                    </ul>
                </div>
                <div class="col-md-3">
                    <h4>Useful Links</h4>
                    <ul class="footerLinks">
                        <li><router-link to="/your_orders">Your Orders </router-link></li>
                        <li><router-link to="/return_policy">Return Policy</router-link></li>
                        <li><router-link to="/faq">FAQ</router-link></li>
                        <li><router-link to="/contact">Wevisu Support</router-link></li>
                        <li><router-link to="/privacy_policy">Privacy Policy</router-link></li>
                        <li><router-link to="/cookies_policy">Cookies Policy </router-link></li>
                        <li><router-link to="/terms_of_service">Terms of Condition</router-link></li>
                    </ul>
                    <div class="p_by"><h4>Powered by </h4><a target="_blank" href="https://wevisu.com/"><img src="/showroom/assets/images/we_visu_2.png" alt=""></a></div>

                </div>
                <div class="col-md-3">
                    <h4>Contact</h4>
                    <ul class="ftrContactDtls">
                        <li><i class="bi bi-geo-alt-fill"></i>2001 GATEWAY PL #425E SAN JOSE, CA 95110</li>
                        <li><i class="bi bi-telephone-fill"></i><a href="tel:(408) 333-9511">(408) 333-9511</a></li>
                        <li><i class="bi bi-envelope-open"></i><a href="mailto:treebuildersgroup@gmail.com">treebuildersgroup@gmail.com</a></li>
                    </ul>
                </div>
            </div>
        </div>
        


        <!-- <h4>Useful Links</h4>
                    <ul class="footerLinks">
                        <li><router-link to="/your_orders">Your Orders </router-link></li>
                        <li><router-link to="/return_policy">Return Policy</router-link></li>
                        <li><router-link to="/faq">FAQ</router-link></li>
                        <li><router-link to="/contact">Wevisu Support</router-link></li>
                        <li><router-link to="/privacy_policy">Privacy Policy</router-link></li>
                        <li><router-link to="/cookies_policy">Cookies Policy </router-link></li>
                        <li><router-link to="/terms_of_service">Terms of Condition</router-link></li>
                    </ul>
                    <div class="p_by"><h4>Powered by </h4><a target="_blank" href="https://wevisu.com/"><img src="/showroom/assets/images/we_visu_3.png" alt=""></a></div> -->




        <div class="popupSideBottom">
        <div class="showPopupBtn">Save up to 30% <i class="bi bi-caret-up-fill"></i></div>
        <button class="closeBtn">
            <i class="bi bi-x-lg"></i>
        </button>
        <div class="content">
            <h3>Save up to 30%</h3>
            <p>Limited-time offer on all finishing materials.</p>
            <form @submit.prevent="submit_query()">
                <input type="text" class="form-control" placeholder="Enter your name" v-model="form.full_name" v-validate="'required'" name="full_name" :class="{ 'is-invalid': verrors.has('full_name') }">
                <input type="text" class="form-control" placeholder="Enter your email address" v-model="form.email" v-validate="'required|email'" name="email" :class="{ 'is-invalid': verrors.has('email') }">
                <input type="text" class="form-control" placeholder="Enter your phone number" v-model="form.phone_number" v-validate="'required'" name="phone_number" :class="{ 'is-invalid': verrors.has('phone_number') }">
                <button class="btn btn-primary" type="submit">Send</button>
            </form>
           
        </div>
    </div>
    </footer> 
    
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
export default {
    name: "Footer",
    data() {
        return {
            baseHref:baseHref,
            year: new Date().getFullYear(),
            is_valid_chat: false,
            form:{}
        };
    },
    computed: {
        ...mapGetters("auth", ["user"]),
        ...mapGetters("Common", ["Setting"]),
        ...mapGetters({ 
            showroomId: "Common/MyItem", 
        }),
        ...mapGetters(["errors"]),
    },
    methods: {
        ...mapActions("Common", ["getSettingData"]),
        submit_query() {
            this.$validator.validateAll().then(async (valid) => {
                if (valid) {

                    let loader = this.$loading.show({ loader: 'dots' })
                    this.form.action = 'handle_external_form_submission'
                    var formData = new FormData();
                     
                    Object.entries(this.form).forEach(([key, value]) => {
                        formData.append(key, value);
                    });
                    

                    formData.append('lead_type', "Pop-Ups");
                    formData.append('shop_profile_id', this.showroomId.showroom);
                    
                    axios.post('/api/sample_request', formData)
                        .then((data) => {
                                loader.hide()
                                if (data.data.success) {
                                    this.form = {};
                                }
                                Toast.fire({
                                    icon: 'success',
                                    title: data.data.message
                                });
                            })
                            .catch(err => {
                                loader.hide()
                            })

                }
            })
        },
    },

    created() {
        this.getSettingData()

    }

};
</script>


<style>
/* Override the default positioning of the toast */
.my-custom-toast-class {
        position: fixed !important; /* Ensure it's fixed relative to the viewport */
        bottom: 0 !important;       /* Align to the bottom of the viewport */
        left: 0 !important;         /* Align to the left of the viewport */
        margin: 16px !important;    /* Optional: add some margin from the edges */
        inset: 0 0 auto auto !important; /* Custom insets */
        background: #ffffff !important; /* Custom background color */
        color: white !important; /* Custom text color */
        z-index: 9999; /* Ensure it's on top */
        height: auto !important;
      }
      
      /* Optionally, remove any backdrop if SweetAlert2 uses it in modals */
      .swal2-container.swal2-top-end.swal2-backdrop-show.my-custom-toast-class {
         background: #ffffff !important;
      }
</style>
